import React from "react";
import { formatDateMonth } from "../../utils/formatDate";
import EllipsisTooltip from "../Common/EllipsisTooltip";

const TableContent = ({ fieldData, dateField }) => {
  const displayValue = dateField
    ? formatDateMonth(dateField)
    : typeof fieldData === "object" && fieldData !== null && fieldData.name
      ? fieldData.name
      : fieldData === 0
        ? 0
        : fieldData || "N/A";

  return (
    <EllipsisTooltip
      title={displayValue}
      sx={{
        padding: "8px 12px",
        textAlign: "left",
        borderRight: "1px solid #ddd",
        paddingLeft: dateField ? "16px" : "12px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "14px",
        color: "black",
        minWidth: 0,
        boxSizing: "border-box",
        display: "block",
      }}
    >
      {displayValue}
    </EllipsisTooltip>
  );
};

export default TableContent;
